import { parseDateTime } from "shared/lib/date/parseDateTime";

// 게시 중(노출 중)인 배너는 최대 3개.
export const MAX_ACTIVE_BANNERS = 3;

export const BANNER_STATE = {
  PUBLISHED: "published", // 게시중 (현재 노출)
  UNPUBLISHED: "unpublished", // 미게시 (직접 내림 + 게시 예정)
  ENDED: "ended", // 게시종료 (게시기간 만료)
};

export const BANNER_STATE_LABEL = {
  [BANNER_STATE.PUBLISHED]: "게시중",
  [BANNER_STATE.UNPUBLISHED]: "미게시",
  [BANNER_STATE.ENDED]: "게시종료",
};

// hide / start / end / now 로 배너 노출 상태를 판정한다.
//  1) hide=true                 → 미게시   (관리자가 직접 내림 / 초안)
//  2) end < now                 → 게시종료 (게시기간 만료, 자동)
//  3) start > now               → 미게시   (게시 예정, 아직 시작 전)
//  4) 그 외(기간 내/미설정)      → 게시중
// start/end는 타임존 없는 KST 벽시계 문자열이라 관리자 로컬(KST)의 new Date()와 비교한다.
export function getBannerState(banner, now = new Date()) {
  if (banner?.hide === true) return BANNER_STATE.UNPUBLISHED;

  const nowMs = now.getTime();

  const end = parseDateTime(banner?.end);
  if (end && end.getTime() < nowMs) return BANNER_STATE.ENDED;

  const start = parseDateTime(banner?.start);
  if (start && start.getTime() > nowMs) return BANNER_STATE.UNPUBLISHED;

  return BANNER_STATE.PUBLISHED;
}

export function getBannerStateLabel(banner, now = new Date()) {
  return BANNER_STATE_LABEL[getBannerState(banner, now)];
}
